export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-2h-34d002b00964f6df4289d92c36562112.webp";